"use client";

import React from "react";
import { Button } from "@/components/ui/button";

export interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
  componentName?: string;
}

export function DefaultSmallFallback({
  resetError,
  componentName,
}: ErrorFallbackProps) {
  return (
    <div className="p-2 alert-error rounded text-center">
      <p className="text-sm text-error mb-2">
        {componentName || "Component"} failed to load
      </p>
      <Button onClick={resetError} variant="error" size="xs">
        Retry
      </Button>
    </div>
  );
}

export function CriticalActionFallback({
  resetError,
  componentName,
}: ErrorFallbackProps) {
  return (
    <div className="p-3 bg-warning-muted border border-border rounded">
      <div className="flex items-center space-x-2">
        <span className="text-warning">⚠️</span>
        <div className="flex-1">
          <p className="text-sm text-warning font-medium">
            {componentName || "Action"} temporarily unavailable
          </p>
          <p className="text-xs text-warning">
            Please refresh the page or try again
          </p>
        </div>
        <Button onClick={resetError} variant="warning" size="xs">
          Retry
        </Button>
      </div>
    </div>
  );
}

export function FormSectionFallback({
  resetError,
  componentName,
}: ErrorFallbackProps) {
  return (
    <div className="p-4 bg-muted border border-border rounded-lg">
      <div className="text-center">
        <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center mx-auto mb-2">
          <span className="text-muted-foreground text-sm">⚠️</span>
        </div>
        <p className="text-sm text-muted-foreground mb-3">
          {componentName || "Form section"} couldn&apos;t load
        </p>
        <Button onClick={resetError} variant="secondary" size="xs">
          Reload section
        </Button>
      </div>
    </div>
  );
}
